import * as Yup from 'yup';

const placeEmployeeSchema = Yup.object({
  ptsPersonID: Yup.number().nullable().required('Employee is required'),
});

export default placeEmployeeSchema;
